import {
  getCurrentProfileSelect,
  PROFILES_ACTION,
  PROFILES_ENDPOINT
} from '@gymaholic/packages'
import saveReduxAction from 'modules/redux/actions/save'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import getIdReduxUtil from 'modules/redux/utils/get-id'

export default function saveProfileAction () {
  return (dispatch, getState) => {
    const profile = getCurrentProfileSelect(getState())

    return dispatch(
      saveReduxAction({
        type: PROFILES_ACTION.SAVE,
        payload: {
          endpoint: getEndpointTrainingUtil(`${PROFILES_ENDPOINT.PROFILES}/${getIdReduxUtil(profile)}`),
          path: getPathReduxUtil(profile)
        }
      })
    )
  }
}
